__turbopack_context__.v({
  "border": "helpCenterGrid-module-scss-module__jCDP6a__border",
  "gridWrapper": "helpCenterGrid-module-scss-module__jCDP6a__gridWrapper",
  "imageWrapper": "helpCenterGrid-module-scss-module__jCDP6a__imageWrapper",
  "listItem": "helpCenterGrid-module-scss-module__jCDP6a__listItem",
  "wrapper": "helpCenterGrid-module-scss-module__jCDP6a__wrapper",
});
